import React from "react";
import SectionTitle from "./SectionTitle";
import { useTranslation } from "react-i18next";
import "../i18n";
import Icon from "./Icons";

const Approach = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: "search",
      title: t("approach_step_one_title"),
      text: t("approach_step_one_text"),
    },
    {
      icon: "tree",
      title: t("approach_step_two_title"),
      text: t("approach_step_two_text"),
    },
    {
      icon: "check",
      title: t("approach_step_three_title"),
      text: t("approach_step_three_text"),
    },
  ];

  return (
    <section id="approach" className="section approach-section">
      <div className="page-container">
        <div className="approach-layout">
          <SectionTitle
            align="left"
            eyebrow={t("approach_eyebrow")}
            title={t("approach_title")}
            subtitle={t("approach_subtitle")}
          />

          <div className="approach-steps">
            {steps.map((step, index) => (
              <div className="approach-step" key={step.title}>
                <div className="approach-step-index">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <span className="approach-step-icon" aria-hidden="true">
                  <Icon name={step.icon} />
                </span>
                <h3>{step.title}</h3>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Approach;
